export enum ProgressPageState {
  None,
  AssessmentSession,
  CFQSession,
  CFQSessionDone,
  EvaluationDone,
}
